import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Link = styled.a`
  align-items: center;
  background: ${props => props.theme.color.buttonStepColor};
  color: ${props => props.theme.color.buttonTextColor} !important;
  display: flex;
  font-family: ${props => props.theme.font.primary};
  font-size: 14px;
  height: 50px;
  list-style-type: none;
  margin: 10px auto;
  padding: 0 10px;
  justify-content: center;
  text-decoration: none;
  text-align: center;
  width: 200px;

  &:hover {
    background: ${props => props.theme.color.buttonStepColorHover};
  }
`;

const NeedHelpLink = styled(Link)`
  font-weight: ${props => props.theme.fontWeight.bold};
  box-shadow: inset 0 0 0 2px ${props => props.theme.color.black};
  color: ${props => props.theme.color.black} !important;
  background: none;

  &:hover {
    box-shadow: inset 0 0 0 2px ${props => props.theme.color.black};
    color: ${props => props.theme.color.black} !important;
    background: ${props => props.theme.color.buttonHelpBgColorHover};
  }
`;

class Action extends React.Component {
  static propTypes = {
    action: PropTypes.object
  };

  render() {
    const { action } = this.props;
    const renderButtonText =
      action.buttonText !== null && action.buttonText !== undefined;
    let nextStepUrl = '';
    if (renderButtonText) {
      nextStepUrl += `/support/help/`;
      nextStepUrl +=
        action.buttonText
          .replace(/ /g, '-')
          .replace(/:/g, '')
          .toLowerCase() + '/';
      nextStepUrl += action.id;
    }

    return renderButtonText ? (
      <Link rel="external" className="brand-button-override" href={nextStepUrl}>
        <div>{action.buttonText}</div>
      </Link>
    ) : (
      <NeedHelpLink href="/owner-center/need-more-help/">
        <div>Need More Help?</div>
      </NeedHelpLink>
    );
  }
}

export default Action;



// WEBPACK FOOTER //
// ./src/components/Actions/Action.js